import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import { FaRegCommentAlt } from 'react-icons/fa';
import { AiFillLike, AiOutlineLike } from 'react-icons/ai';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import Perfil from '../../assests/avatar.png';
import { calculaTempo } from '../../global';
import { TextoComBandeiras, cortarTexto } from '../../bandeiras';
import dateFormat from 'dateformat';
import { useTranslation } from 'react-i18next';

import './styles.css';

function lerTagsMsg() {
  try {
    const raw = sessionStorage.getItem('tagsMsg');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

export default function TimelineBusca() {
  const { t } = useTranslation();
  const history = useHistory();
  const [hashTag, setHashTag] = useState('');
  const [dataInicial, setDataIncial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [TAGS, setTAGS] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem('TAGS'));
      return Array.isArray(cached) ? cached : [];
    } catch (err) {
      return [];
    }
  });
  const [vetTag, setVetTag] = useState(() => lerTagsMsg());
  const [by_date_after, setBy_date_after] = useState('');
  const [by_date_before, setBy_date_before] = useState('');
  const [tagfiltro, setTagfiltro] = useState('');
  const [state_code, setState_code] = useState('');
  const [tituloPagina, setTituloPagina] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [filtroAplicado, setFiltroAplicado] = useState(false);
  const [tagsOpen, setTagsOpen] = useState(false);
  const [tagQuery, setTagQuery] = useState('');
  const [selecionadas, setSelecionadas] = useState(() => {
    try {
      const raw = sessionStorage.getItem('tagsMsg');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  });
  const tagsBoxRef = useRef(null);
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);
  const buscaId = useRef(0);

  function tagLabel(name) {
    const bruto = String(name || '').trim();
    if (!bruto) return '';
    const comHash = bruto.charAt(0) === '#' ? bruto : `#${bruto}`;
    return comHash.toUpperCase();
  }

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [atualiza, setAtualiza] = useState('');
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');


  const PARAMS = "";


  // async function pegarTags() {
  //   await api.get('/v4/tags', {
  //     headers: {
  //       'USER_EMAIL': USER_EMAIL,
  //       'USER_TOKEN': USER_TOKEN,
  //       'Content-Type': 'application/json'
  //     }
  //   }).then(response => {
  //     let filtro = response.data;
  //     let novaTag = filtro.filter(x => x.is_negotiation === true).map(x => x);
  //     sessionStorage.setItem('TAGS', JSON.stringify(novaTag));
  //   })

  // }
  // pegarTags();

  api.get(`/v4/users/me`, {
    headers: {
      'USER_EMAIL': USER_EMAIL,
      'USER_TOKEN': USER_TOKEN,
    }
  }).then(response => {

  }).catch(err => {
    if (err.status === 401) {
      history.push('/');
    }
  });

  
  useEffect(() => {
    let cancelled = false;
    loadingRef.current = true;
    setLoadingMore(true);
    if (page === 1 && filtroAplicado) {
      setCarregando(true);
    }

    let v_tags = '';
    try {
      const raw = sessionStorage.getItem('tagsMsg');
      const vetTags = raw ? JSON.parse(raw) : [];
      if (Array.isArray(vetTags) && vetTags.length) {
        v_tags = vetTags.map((v) => 'by_tags[]=%23' + String(v.name || '').replace('#', '')).join('&');
        if (v_tags) v_tags = '&' + v_tags;
      }
    } catch (err) {
      v_tags = '';
    }

    var url = `/v6/posts?page=${page}&by_date_after=${by_date_after}&by_date_before=${by_date_before}&by_kind=feed&by_state=${state_code}${v_tags}`;
    const id = buscaId.current + 1;
    buscaId.current = id;
    api.get(url, {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
        'PARAMS': PARAMS,
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (cancelled || id !== buscaId.current) {
        return;
      }
      const data = Array.isArray(response.data) ? response.data : [];
      setPosts((prev) => {
        const next = page === 1 ? data : prev.concat(data);
        sessionStorage.setItem('sPosts', JSON.stringify(next));
        return next;
      });
      setHasMore(data.length > 0);
      sessionStorage.setItem('page', page);
      setCarregando(false);
    }).catch(err => {
      if (cancelled || id !== buscaId.current) {
        return;
      }
      setCarregando(false);
      if (err.status === 401) {
        history.push('/');
      }
    }).then(() => {
      if (!cancelled && id === buscaId.current) {
        loadingRef.current = false;
        setLoadingMore(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [USER_EMAIL, USER_TOKEN, atualiza, history, page]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      if (loadingRef.current || !hasMore) return;
      setPage((current) => current + 1);
    }, { rootMargin: '240px' });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, posts.length]);

  useEffect(() => {
    function fecharTags(e) {
      if (tagsBoxRef.current && !tagsBoxRef.current.contains(e.target)) {
        setTagsOpen(false);
      }
    }
    document.addEventListener('mousedown', fecharTags);
    return () => document.removeEventListener('mousedown', fecharTags);
  }, []);

  function Description(props) {
    return (
      <p className="description"><TextoComBandeiras texto={cortarTexto(props.texto || '', 220)} /></p>
    )
  }
  function quebra(texto) {

  }

  function mostraFree(visible) {
    const vPlan = JSON.parse(sessionStorage.getItem('plan')).name;
    if (vPlan === 'Consultoria gratuita') {
      if (visible === true) {
        return ('mostrarPost')
      } else {
        //return ('esconderPost')
        return ('mostrarPost')
      }
    } else {
      return ('mostrarPost')
    }
  }

  function curtir(id, evaluation) {
    evaluation === null ? evaluation = true : evaluation = null;
    var axios = require('axios');
    var data = JSON.stringify({ "evaluation": evaluation });
    var config = {
      method: 'post',
      url: BASE_URL + `/v6/posts/${id}/evaluate`,
      headers: {
        'Content-Type': 'application/json',
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN
      },
      data: data
    };
    axios(config)
      .then(function () {
        setPosts((prev) => (Array.isArray(prev) ? prev : []).map((post) => (
          Number(post.id) === Number(id)
            ? { ...post, evaluation: true, ups_count: (parseInt(post.ups_count, 10) || 0) + 1 }
            : post
        )));
      })
      .catch(function (error) {
      });

  }
  function Like(props) {
    var evaluation = props.evaluation;
    if (evaluation === true) {
      evaluation = true;
      return (
        <button type="button" onClick={() => curtir(props.id, evaluation)}>
          <AiFillLike size={18} color="#00b8ff" />
          <span className="like">{props.count}</span>
        </button>
      )
    } else {
      evaluation = null;
      return (
        <button type="button" onClick={() => curtir(props.id, evaluation)}>
          <AiOutlineLike size={18} color="#6b7280" />
          <span className="like">{props.count}</span>
        </button>

      )
    }

  }

  function verificaTag(tagsId) {
    const result = selecionadas.find((tag) => Number(tag.id) === Number(tagsId));
    return result ? 'tagON' : 'tagOFF';
  }

  function selecionaTag(tagsId) {
    const id = Number(tagsId);
    let vet = [...selecionadas];
    const jaTem = vet.find((tag) => Number(tag.id) === id);
    if (!jaTem) {
      if (vet.length >= 7) {
        alert(t('pages.profileInterests.messages.maxOfTags'));
        return;
      }
      const found = (TAGS || []).find((tag) => Number(tag.id) === id);
      if (found) {
        vet = [...vet, found];
        setSelecionadas(vet);
        sessionStorage.setItem('tagsMsg', JSON.stringify(vet));
      }
    } else {
      vet = vet.filter((tag) => Number(tag.id) !== id);
      setSelecionadas(vet);
      sessionStorage.setItem('tagsMsg', JSON.stringify(vet));
    }
  }
  function Imagem(props) {
    return (
      <img src={props.url} alt="" />
    )
  }
  function filtrar() {
    if (carregando) {
      return;
    }
    setFiltroAplicado(true);
    setCarregando(true);
    setPosts([]);
    setHasMore(true);
    setPage(1);
    let vetTags = [];
    try {
      const raw = sessionStorage.getItem('tagsMsg');
      const parsed = raw ? JSON.parse(raw) : [];
      vetTags = Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      vetTags = [];
    }
    let vetorTags = '';
    vetTags.forEach((v) => {
      vetorTags += v.name + ', ';
    });
    vetorTags = vetorTags.substring(0, vetorTags.length - 2);

    if (vetTags.length > 0) {
      setHashTag(vetTags[0].slug);
    }
    console.log('by_date_after' + by_date_after);
    const datas = [];
    if (by_date_after) {
      datas.push(dateFormat(by_date_after, 'dd/mm/yyyy', true));
    }
    if (by_date_before) {
      datas.push(dateFormat(by_date_before, 'dd/mm/yyyy', true));
    }
    const resumo = [datas.join(' – '), vetorTags].filter(Boolean).join(' · ');
    setTituloPagina(resumo ? t('pages.timelineSearch.labels.results') + resumo : '');
    setAtualiza(Math.random());
  }
  return (
    <FeedLayout active="search">
    <div className="timeline-busca-container">
      <div className="feed-top">{t('pages.timelineSearch.labels.filter')}</div>
      <div className="busca">
        <label>{t('pages.timelineSearch.labels.dateInit')}</label>
        <input type="date" id="dataInicial" defaultValue={by_date_after} onChange={e => setBy_date_after(e.target.value)} />
        <label>{t('pages.timelineSearch.labels.dateEnd')}</label>
        <input type="date" id="dataFinal" defaultValue={by_date_before} onChange={e => setBy_date_before(e.target.value)} />
      </div>
      <div className="clTags" ref={tagsBoxRef}>
        <label>{t('pages.timelineSearch.labels.tags')}</label>
        <button
          type="button"
          className="tags-select"
          onClick={() => {
            try {
              const cached = JSON.parse(sessionStorage.getItem('TAGS'));
              if (Array.isArray(cached)) setTAGS(cached);
            } catch (err) {}
            setTagsOpen(!tagsOpen);
          }}
        >
          <span>
            {selecionadas.length
              ? `${selecionadas.length} selecionada${selecionadas.length > 1 ? 's' : ''}`
              : t('pages.timelineSearch.select.tags')}
          </span>
          <FiChevronDown />
        </button>
        {tagsOpen && (
          <div className="tags-panel">
            <div className="tags-search">
              <FiSearch />
              <input
                type="text"
                value={tagQuery}
                onChange={(e) => setTagQuery(e.target.value)}
                placeholder={t('pages.timelineSearch.placeholders.searchTag')}
                autoFocus
              />
            </div>
            <ul className="tags-list">
              {(TAGS || [])
                .filter((tag) => {
                  const q = tagQuery.trim().toLowerCase();
                  if (!q) return true;
                  const bruto = String(tag.name || '').toLowerCase();
                  const amigavel = tagLabel(tag.name).toLowerCase();
                  return bruto.indexOf(q) !== -1 || amigavel.indexOf(q) !== -1;
                })
                .map((tag) => (
                  <li
                    key={tag.id}
                    className={verificaTag(tag.id) === 'tagON' ? 'is-on' : ''}
                    onClick={() => selecionaTag(tag.id)}
                  >
                    {tagLabel(tag.name)}
                  </li>
                ))}
            </ul>
          </div>
        )}
        {selecionadas.length > 0 && (
          <div className="tags-chosen">
            {selecionadas.map((tag) => (
              <button
                type="button"
                key={tag.id}
                className="tag-chip"
                onClick={() => selecionaTag(tag.id)}
              >
                {tagLabel(tag.name)} ×
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="clUF">
        <label>{t('pages.timelineSearch.labels.state')}</label>
        <select id='slEstado' onChange={e => setState_code(e.target.value)}>
          <option value="" selected>{t('pages.timelineSearch.select.states')}</option>
          <optgroup label={t('commons.regions.regiaoNorte')}></optgroup>
          <option value="12">{t('commons.states.acre')}</option>
          <option value="16">{t('commons.states.amapa')}</option>
          <option value="13">{t('commons.states.amazonas')}</option>
          <option value="14">{t('commons.states.roraima')}</option>
          <option value="11">{t('commons.states.rondonia')}</option>
          <option value="15">{t('commons.states.para')}</option>
          <option value="17">{t('commons.states.tocantins')}</option>
          <optgroup label={t('commons.regions.regiaoNordeste')}></optgroup>
          <option value="27">{t('commons.states.alagoas')}</option>
          <option value="29">{t('commons.states.bahia')}</option>
          <option value="23">{t('commons.states.ceara')}</option>
          <option value="21">{t('commons.states.maranhao')}</option>
          <option value="22">{t('commons.states.piaui')}</option>
          <option value="25">{t('commons.states.paraiba')}</option>
          <option value="26">{t('commons.states.pernanbuco')}</option>
          <option value="24">{t('commons.states.rioGrandeDoNorte')}</option>
          <option value="28">{t('commons.states.sergipe')}</option>
          <optgroup label={t('commons.regions.regiaoSudeste')}></optgroup>
          <option value="32">{t('commons.states.espiritoSanto')}</option>
          <option value="31">{t('commons.states.minasGerais')}</option>
          <option value="33">{t('commons.states.rioDeJaneiro')}</option>
          <option value="35">{t('commons.states.saoPaulo')}</option>
          <optgroup label={t('commons.regions.regiaoSul')}></optgroup>
          <option value="41">{t('commons.states.parana')}</option>
          <option value="42">{t('commons.states.santaCatarina')}</option>
          <option value="43">{t('commons.states.rioGrandeDoSul')}</option>
          <optgroup label={t('commons.regions.regiaoCentroOeste')}></optgroup>
          <option value="53">{t('commons.states.distritoFederal')}</option>
          <option value="52">{t('commons.states.goias')}</option>
          <option value="51">{t('commons.states.matoGrosso')}</option>
          <option value="50">{t('commons.states.matoGrossodoSul')}</option>
        </select>
      </div>
      <div className="btn-filtro">
        <button type="button" onClick={filtrar} disabled={carregando}>
          {carregando && filtroAplicado
            ? t('pages.timelineSearch.buttons.loading')
            : t('pages.timelineSearch.buttons.apply')}
        </button>
        <Link className="fecharFiltro" to="/timeline">{t('pages.timelineSearch.buttons.close')}</Link>
      </div>
      {carregando && filtroAplicado ? (
        <div className="feed-top-sub">{t('pages.timelineSearch.labels.loading')}</div>
      ) : tituloPagina ? (
        <div className="feed-top-sub">{tituloPagina}</div>
      ) : null}
      <section className="body">
        <ul>
          {
            posts.map((post, index) => (
              // <li key={post.id} >
              <li key={index} className={mostraFree(post.is_free_visible)}>
                <p className="nomeProf"><img className="imgProf" src={post.user && post.user.avatar && post.user.avatar.medium ? post.user.avatar.medium : Perfil} alt="" /><span className="nome">{post.user && post.user.name}</span><span className="tempo">  ·  {calculaTempo(post.created_at)}</span></p>
                <div className="containerTag">
                  <p className="tags">
                    {(post.tags || []).map(tag => (
                      <div className="clTag" key={tag.id}><span>{tag.name}</span></div>
                    ))
                    }
                  </p>
                </div>
                <p className="title"><TextoComBandeiras texto={post.title} /></p>
                <Description texto={post.description} />
                <Imagem url={(!post.image) ? "null" : post.image.medium} />
                <p className="lermais">
                  <Link
                    to={`/post/${post.id}`}
                    className="lermais"
                    onClick={() => sessionStorage.setItem('sPostDetalhe', JSON.stringify(post))}
                  >
                    {t('pages.timelineSearch.keepReading')}
                  </Link>
                </p>
                <p className="icons">
                  <Like count={post.ups_count} id={post.id} evaluation={post.evaluation} />
                  <span className="coment"><FaRegCommentAlt size={18} color="#6b7280" /><span className="like">{parseInt((post.first_comments || []).length)}</span></span></p>
              </li>
            ))}
        </ul>
        <div className="feed-sentinel" ref={sentinelRef}>
          {loadingMore && <span>Carregando mais publicações…</span>}
          {!loadingMore && !hasMore && posts.length > 0 && (
            <span>Você viu as publicações mais recentes</span>
          )}
        </div>
      </section>
    </div>
    </FeedLayout>
  );
}